

exports.__esModule = true;

var _ng = require('./ng');

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _core = require('./core');

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _locale = require('./locale');

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _paypal = require('./paypal');

Object.keys(_paypal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paypal[key];
    }
  });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/index.js
 ** module id = 114
 ** module chunks = 1
 **/